"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateIOSTokenVariantCommand = void 0;
const AbstractCreateVariantCommand_1 = require("./AbstractCreateVariantCommand");
class CreateIOSTokenVariantCommand extends AbstractCreateVariantCommand_1.AbstractCreateVariantCommand {
    constructor(api, appId) {
        super(api, appId, 'ios_token');
        this.withTeamID = (teamId) => {
            this.def.teamId = teamId;
            return this;
        };
        this.withKeyID = (keyId) => {
            this.def.keyId = keyId;
            return this;
        };
        this.withBundleID = (bundleId) => {
            this.def.bundleId = bundleId;
            return this;
        };
        this.withPrivateKey = (privateKey) => {
            this.def.privateKey = privateKey;
            return this;
        };
        this.isProduction = () => {
            this.def.production = true;
            return this;
        };
        this.isDevelopment = () => {
            this.def.production = false;
            return this;
        };
        this.def.type = 'ios_token';
    }
}
exports.CreateIOSTokenVariantCommand = CreateIOSTokenVariantCommand;
//# sourceMappingURL=CreateIOSTokenVariantCommand.js.map